import api from "@/assets/scripts/api";
import { randomItemOfArr } from "@/assets/scripts/common.js";
import { uploadImg } from "@/assets/scripts/features";
import { base64toFile, downLoadDesign } from "@/assets/scripts/utils";
import { iconStyleMap, mainTextStyles } from "@/pages/poster/js/poster-static";
import http from "@/plugins/http";
import { htmlToCanvas } from "@assets/scripts/features";
import Message from "element-ui";
// 提交用户设计
export const updateScheme = async scheme => {
  try {
    let result = await http.post(api.scheme, scheme);
    return result;
  } catch (error) {
    console.error(error);
    return {};
  }
};
// 获取海报内容区的背景列表
export const getContentStyles = async tagId => {
  const params = {
    pageSize: 200,
    pageIndex: 1,
    isPageTitle: false,
  };
  tagId && (params.tagId = tagId);
  try {
    let result = await http.get(api.contentBgs, params);
    if (result.code === 10000) {
      return result.data.list;
    }
    return [];
  } catch (error) {
    return [];
  }
};
// 获取poster详情
export const getPosterDetail = async schemeId => {
  try {
    let { data } = await http.get(`${api.scheme}?schemeId=${schemeId}&platformType=3`);
    return data;
  } catch (error) {
    return {};
  }
};
// 获取海报长图详情
export const getPosterLongDetail = async (schemeId) => {
  try {
    const result = await http.get(
      `${api.posterLongDetail}?schemeId=${schemeId}`
    );
    if (!result || result.code !== 10000 || !result.data || Array.isArray(result.data)) {
      return {};
    }
    return result.data;
  } catch (error) {
    return {};
  }
};
// 把方案里的 logoId 映射成站点对象，过滤已删除/未找到的项，避免 item.id 读到 undefined
export const resolvePosterLogos = (logos, logoOptions = []) => {
  const ids = String(logos || "")
    .split(",")
    .map(item => Number(String(item).trim()))
    .filter(id => Number.isFinite(id) && id > 0);
  return ids
    .map(id => logoOptions.find(logo => Number(logo.id) === id))
    .filter(Boolean);
};
export const genSizeStyleTextInfo = ({
  sizeInfo,
  // textStyles,
  fontId,
  // tagId,
}) => {
  const {
    id,
    offsetX,
    offsetY,
    remainPart,
    textAlignType,
    textPositionX,
    textPositionY,
    elementHeight,
    elementWidth,
    width,
    height,
    sizeName,
  } = sizeInfo;
  const elementInfo = {
    elementHeight,
    elementWidth,
    offsetX,
    offsetY,
    remainPart,
  };
  const size = {
    width,
    height,
  };
  const textInfo = {
    textAlignType,
    textPositionX,
    textPositionY,
    textCountLimit: [],
  };
  return {
    elementInfo,
    size,
    textInfo,
    sizeId: id || 0,
    sizeName: sizeName || "",
    textStyleId: fontId,
  };
};
// 生成全面的文字样式，接口只返回了主副标题的文字样式，其余9行文字样式默认生成
export const genTextStyles = (textStyles, { contentStyles, tagId = "", iconStyle, contentStyle } = {}) => {
  // 随机生成一个内容区域的icon的样式
  const itemIconStyle = iconStyle || randomIconStyle();
  const styles = [];
  for (let i = 0; i < mainTextStyles.length; i++) {
    const s = textStyles[i] || {};
    if (s.textCountLimit) {
      let arr = s.textCountLimit.split("<x<");
      s.max = arr[1];
      s.min = arr[0];
    }
    // 随机生成一个内容区域的框的样式
    if (mainTextStyles[i].enName === "contentTitle" && tagId) {
      mainTextStyles[i].labelStyle = contentStyle || (contentStyles && randomItemOfArr(contentStyles).id);
    }
    if (mainTextStyles[i].enName.includes("item")) {
      // 将随机生成的icon样式赋给内容区条目
      mainTextStyles[i].labelStyle = itemIconStyle;
    }
    styles[i] = {
      ...mainTextStyles[i],
      ...s,
      showLabelStyle: !!s.labelStyle || !!mainTextStyles[i].showLabelStyle,
    };
  }
  return styles;
};
// 随机生成一个内容框样式
export function randomContentStyleByTag (contentStyles, tagId) {
  if (!tagId) return randomItemOfArr(contentStyles).id;
  // tagId的可能值: "1,2,52" || "2" || 2
  tagId = tagId + "";
  const tagIds = tagId.split(",").map(id => parseInt(id));
  const styles = [];
  tagIds.forEach(tagId => {
    contentStyles.forEach(style => {
      if (style.tagIds.includes(tagId)) {
        styles.push(style);
      }
    });
  });
  return randomItemOfArr(styles);
}
// 随机生成内容区域条目icon的样式
export function randomIconStyle () {
  return randomItemOfArr(Object.values(iconStyleMap)).id;
}
// 替换文字的内容框样式和内容条目icon样式
export function genTextStylesByIconStyle (
  posterTextMaps,
  iconStyle
) {
  const textMaps = JSON.parse(JSON.stringify(posterTextMaps));
  textMaps[1].editOptions.items[0].content.labelStyle = iconStyle;
  return textMaps;
}
// 提交用户设计
export const savePosterToBase = async (posterDataList, id = "") => {
  if (!posterDataList.length) {
    return null;
  }
  let { tagId, elementId, textStyleId, backgroundId } = posterDataList[0];
  // 去掉重复的站点
  const posters = filterRepeatPoster(posterDataList);
  const sizeTexts = posters.map(posterData => ({
    sizeId: posterData.sizeId,
    texts: posterData.textValue,
    labelStyle: posterData.textStyle.map(item => {
      return item.showLabelStyle ? item.labelStyle : "";
    }),
  }));
  let scheme = {
    id,
    tagId,
    elementId,
    backgroundId,
    textStyleId,
    platformType: 3,
    sizeTexts,
  };
  return await updateScheme(scheme);
};
// 海报有重复的
export const filterRepeatPoster = posterDataList => {
  let posters = JSON.parse(JSON.stringify(posterDataList));
  const siteMap = {};
  posters.forEach(item => {
    siteMap[item.textValue[item.textValue.length - 1]] = true;
  });
  const filteredPosters = [];
  Object.keys(siteMap).forEach(siteId => {
    const poster = posters.find(item => parseInt(siteId) === item.textValue[item.textValue.length - 1]);
    poster && filteredPosters.push(poster);
  });
  return filteredPosters;
};
// 上传二维码图片
export const onUpload = async imgBase64Data => {
  const formData = new FormData();
  formData.append(
    "file",
    base64toFile(
      imgBase64Data,
      Math.random().toString(36).slice(-8) // 随机生成名字
    )
  );
  let { data } = (await uploadImg(formData)) || {};
  // let { data } = await compress(formData);
  if (!data || !data.result) {
    Message.warning("上传失败，请重新上传");
    return "";
  }
  return `//bar.xkw.com${data.result}`;
};
// 检查poster文字是否合法
export const checkPosterTextValue = (styles, values) => {
  let isAllTextLegal = true;
  for (let i = 0; i < styles.length; i++) {
    const styleMap = styles[i];
    const text = values[i];
    if (styleMap.enName === "item4" && !text) {
      styleMap.isVali = true;
      continue;
    }
    if (styleMap.enName === "logo") {
      styleMap.isVali = true;
      continue;
    }
    if (!text || text.length < parseInt(styleMap.min) || text.length > parseInt(styleMap.max)) {
      styleMap.isVali = false;
      isAllTextLegal = false;
      styleMap.isSensitive = false;
      break;
    } else {
      styleMap.isVali = true;
    }
    // const isChecked = await textCheck(text);
    // styleMap.isSensitive = !isChecked;
    styleMap.isSensitive = false;
    if (styleMap.isSensitive) {
      isAllTextLegal = false;
      break;
    }
  }
  return isAllTextLegal;
};

// 获取业务线logo
export const getLogos = async () => {
  try {
    let result = await http.get(api.logos, {
      pageSize: 10000,
      pageIndex: 1,
    });
    if (result.code === 10000) {
      return result.data.list || [];
    }
    return [];
  } catch (error) {
    return [];
  }
};
// 兼容旧版poster的contentBgStyle和logoId
export const compatibleOldVesrion = posters => {
  // 将旧版的textValue中的logo-1改为1，将textStyle[2]中的labelStyle:'poster-style-20'改为20
  posters.forEach(item => {
    const contentBgId = item.textStyle[2].labelStyle;
    const logoId = item.textValue[10];
    if (/^poster-style/.test(contentBgId)) {
      const arr = contentBgId.split("-");
      item.textStyle[2].labelStyle = parseInt(arr[arr.length - 1]) || 1;
    } else {
      item.textStyle[2].labelStyle = parseInt(contentBgId);
    }
    if (/^logo/.test(logoId)) {
      const arr = logoId.split("-");
      item.textValue[10] = parseInt(arr[1]);
    } else {
      item.textValue[10] = parseInt(logoId);
    }
  });
};
// 提交用户设计
export const savePosterLongToBase = async (posterData, posterTextMaps, id = "", userId = "") => {
  let { tagId, elementId, textStyleId, backgroundId, sizeId, logos, contentStyleId, portraitInfo, isAiElement } = posterData;
  let scheme = {
    id,
    tagId,
    elementId,
    isAiElement,
    backgroundId,
    textStyleId,
    sizeId,
    logos: (logos || []).filter(item => item && item.id != null).map((item) => item.id),
    contentStyleId,
    teacherNameLableStyleId: portraitInfo.labelStyle,
    posterTextMaps,
  };
  if (userId) {
    return await http.post(api.savePosterByUser, {
      ...scheme,
      userId,
    }).catch((err) => {
      console.log("报错cover失败", err);
    });
  }
  return await http.post(api.posterLongScheme, scheme);
};

// 绘制海报长图
export const drawPosterLong = async (posterData, name) => {
  // 绘制
  const imgMaps = [];
  for (let i = 0; i < posterData.logos.length; i++) {
    let drawedDom = document.querySelector("#" + name + i);
    const base64Data = await htmlToCanvas(drawedDom, 2);
    imgMaps.push({
      name: posterData.logos[i].logoName,
      data: base64Data,
    });
  }
  return await downLoadDesign(imgMaps, name);
};
// 获取海报长图列表
export const getPosterList = async ({
  pageSize,
  pageIndex,
  userId,
}) => {
  let result = {};
  if (userId) {
    result = await http.get(api.posterListByUserId, {
      pageSize,
      pageIndex,
      userId,
    });
  } else {
    result = await http.get(api.posterList, {
      pageSize,
      pageIndex,
    });
  }

  if (result.code === 10000) {
    return result.data;
  }
  return {
    list: [],
    totalPage: 0,
    totalCount: 0,
    pageIndex: 0,
    pageSize: 0,
  };
};
export const deletePoster = async (id, userId) => {
  if (userId) {
    let { data } = await http.get(api.deletePosterByUserId + '?id=' + id + '&userId=' + userId);
    return data
  }
  let { data } = await http.get(api.deletePoster + '?id=' + id);
  return data
}